import { ArrowRightOutlined } from '@ant-design/icons';
import { Heading } from '@mm/components';
import { useResolutionInfo } from '@mm/hooks';
import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { MOBILE_SMALL } from '../../../../../../../../editor/constants/screenSize';
import styles from './VideoOnboarding.module.css';
import LarryIcon from '../larry.svg';

type Props = {
  videoSrc: string;
  videoDescription?: {
    description?: string;
    descriptionLineTwo?: string;
    descriptionHeader?: string;
    descriptionImage?: string;
  };
  videoButton?: {
    text: string;
    action: () => void;
  };
};

export const VideoOnboarding = (props: Props) => {
  const { videoSrc, videoDescription, videoButton } = props;
  const [disabledBtn, setDisabledBtn] = useState(true);
  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_SMALL;

  useEffect(() => {
    const timeoutId = setTimeout(() => setDisabledBtn(false), 3000);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.videoContainer}>
        <iframe
          title="vimeo-player"
          src={videoSrc}
          width={isMobile ? '360' : '640'}
          height={isMobile ? '240' : '320'}
          frameBorder="0"
          allowFullScreen
          allow="autoplay"
        />
        <div className={styles.underVideoText}>
          This video is played automatically without a sound. You can turn
          on/off sound.{' '}
        </div>
      </div>
      <div className={styles.descriptionContainer}>
        {videoDescription?.descriptionHeader && (
          <Heading className={styles.descriptionHeader} size={3}>
            {videoDescription.descriptionHeader}
          </Heading>
        )}
        <div className={styles.descrptionWithImageContainer}>
          <div className={styles.description}>
            {videoDescription?.description}
          </div>
          {videoDescription?.descriptionLineTwo && (
            <div className={styles.description}>
              {videoDescription?.descriptionLineTwo}
            </div>
          )}
        </div>
        <div className={styles.primaryButtonContainer}>
          <PrimaryButton
            onClick={() => videoButton?.action()}
            disabled={disabledBtn}
            className={styles.primaryButton}
          >
            <ArrowRightOutlined className={styles.arrowIcon} size={10} />
            {videoButton?.text}
          </PrimaryButton>
        </div>

        {videoDescription && (
          <div className={styles.signature}>
            <img src={LarryIcon} alt="Larry Kim" />
            <div className={styles.textSignature}>
              <span className={styles.sincerely}>Sincerely,</span>
              <span>Larry Kim</span>
              <span>Founder & CEO</span>
              <span>MobileMonkey & Team</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
